// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__rH3wW","search":"Settings_search__RrtVN","filter":"Settings_filter__3kvtS"};